import { FC } from 'react';
import classnames from 'classnames';
import { translate } from 'translations';
import { Icon, Divider } from 'learning-panel-components';
import moment from 'moment';
import styles from './tournamentCard.module.scss';

const TournamentCard: FC<TournamentCardProps> = (props: TournamentCardProps) => {
    const { name, score, date, rounds, participants, tournamentUrl } = props;

    return (
        <div className={classnames(styles.card)}>
            <a href={tournamentUrl} className={styles.language}>
                <div className={styles.top}>
                    <img
                        src={`${process.env.PUBLIC_URL}/images/tournamentCard.svg`}
                        className={styles.img}
                        alt="tournamentCard"
                    />
                    <div className={styles['image-overly']}></div>

                    <div className={styles['score-circle']}>
                        <div className={styles['score-wrapper']}>
                            <div className={styles['your-score']}>{translate('YourScore')}</div>
                            <div className={styles['score-points']}>
                                <Icon name="devCoin" className={styles.icon} />
                                <div className={styles.points}>{score}</div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.language}>{translate('SeeResults')}</div>
                </div>
                <div className={styles.bottom}>
                    <div className={styles['title-date']}>
                        <div className={styles.title}>
                            <Icon name="tournamentIcon" className={styles['type-icon']} />
                            <div className={styles.text}>{translate('TOURNAMENT')}</div>
                        </div>
                        <div className={styles.date}>{moment(date).format('MMM D YYYY')}</div>
                    </div>
                    <div className={styles.name}>{name}</div>
                    <div className={styles['details-wrapper']}>
                        <div className={styles.details}>
                            <Icon name="rounds" className={styles['type-icon']} />
                            <div className={styles.text}>{rounds}</div>
                        </div>
                        <Divider orientation="vertical" className={styles.divider} color="rgba(255, 255, 255, 0.5)" />
                        <div className={styles.details}>
                            <Icon name="people" className={styles['type-icon']} style={{ marginTop: '0.2rem' }} />
                            <div className={styles.text}>{participants}</div>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
};

interface TournamentCardProps {
    name: string;
    score?: number;
    isOver: boolean;
    rounds: number;
    participants: number;
    date: Date;
    tournamentUrl: string;
}

export default TournamentCard;
